import { render, staticRenderFns } from "./ModalCantCreateAccount.vue?vue&type=template&id=bba07192&"
import script from "./ModalCantCreateAccount.vue?vue&type=script&lang=js&"
export * from "./ModalCantCreateAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports